import { useTranslation } from 'react-i18next'

import { ComboBox } from '@reveni-io/reveni-ui'

import ScenarioCard from '@/configuration/pages/ConfigurationPage/OrderTrackingPageConfiguration/TrackingPageEditorModal/PreviewSettingsSidebar/CustomScenarioSettings/ScenarioCard/ScenarioCard'

import { getOperationResultOptions } from './helpers'

const ScenarioReturnRequestCard = ({ returnRequest, position, onChange, onRemove }) => {
  const { t } = useTranslation()

  const operationResultOptions = getOperationResultOptions(t)

  const handleChangeOperationResult = event => onChange(returnRequest.id, { operationResult: event.target.value })

  const handleRemove = () => onRemove(returnRequest.id)

  return (
    <ScenarioCard
      title={t('Solicitud de devolución #{{number}}', { number: position })}
      removeLabel={t('Eliminar solicitud de devolución #{{number}}', { number: position })}
      testId={`scenario-return-request-${position}`}
      onRemove={handleRemove}
    >
      <ComboBox
        fullWidth
        label={t('Resultado de la operación')}
        menuItems={operationResultOptions}
        value={returnRequest.operationResult}
        handleChange={handleChangeOperationResult}
      />
    </ScenarioCard>
  )
}

export default ScenarioReturnRequestCard
